/* ============================================================
   CTA convention helpers — keep CMS-edited href fields uniform.

   `#contact`        → open the slide-in Contact panel
   ""  / null        → open the slide-in Contact panel
   `mailto:` `tel:`  → native handler (preserved as plain anchor)
   `http(s)://…`     → external link (new tab)
   `/path`           → internal React Router link
============================================================ */

export const isContactHref = (href) => {
  if (!href) return true;
  const v = String(href).trim().toLowerCase();
  return v === "#contact" || v === "contact-panel";
};

export const isExternalHref = (href) => {
  if (!href) return false;
  return /^(https?:|mailto:|tel:)/i.test(String(href).trim());
};

export const isInternalHref = (href) => {
  if (!href) return false;
  return String(href).trim().startsWith("/");
};

/* Hint line reused by every href field in the CMS schemas */
export const HREF_HINT =
  "Use `#contact` (or leave blank) to open the in-site Contact panel. Otherwise: `/path` for internal pages, `https://…` for external, `mailto:` / `tel:` for direct.";
